var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.634,
    height: 18.761,
    viewBox: "0 0 10.634 18.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-facebook",
    "data-name": "Icon feather-facebook",
    d: "M20.434,3H17.724a4.515,4.515,0,0,0-4.515,4.515v2.709H10.5v3.612h2.709v7.224h3.612V13.837h2.709l.9-3.612H16.821V7.515a.9.9,0,0,1,.9-.9h2.709Z",
    transform: "translate(-10.15 -2.65)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook2);
export default __webpack_public_path__ + "static/media/facebook2.58e63ca9d554ef1cf55d3261f706dd69.svg";
export { ForwardRef as ReactComponent };